import { Button, Heading, Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { createCallable } from 'react-call';
import { content } from './InfoModal.content';

type ContentProps =
  | {
      text: string;
      children?: never;
    }
  | {
      children: React.ReactNode;
      text?: never;
    };

export function InfoModal({
  isOpen,
  onClose,
  title,
  text,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
} & ContentProps) {
  const localizedContent = useContent(content);

  return (
    <DialogOrBottomSheet
      isOpen={isOpen}
      blurEnabled={true}
      onClose={onClose}
      backgroundColor="#0C1C2C">
      <div className="flex flex-col my-4 w-full items-center px-4">
        <Heading level={4}>{title}</Heading>
        {text ? (
          <Typography
            size="large"
            weight="medium"
            className="my-8 text-center text-[#A4A7C1]">
            {text}
          </Typography>
        ) : (
          <>{children}</>
        )}
        <Button
          color="primary"
          size="large"
          text={localizedContent.gotIt}
          onPress={onClose}
          className="w-full"
        />
      </div>
    </DialogOrBottomSheet>
  );
}

export const InfoModalCallable = createCallable<
  {
    title: string;
  } & ContentProps,
  boolean
>(({ call, title, text, children }) =>
  text ? (
    <InfoModal
      isOpen
      title={title}
      text={text}
      onClose={() => call.end(true)}
    />
  ) : (
    <InfoModal isOpen title={title} onClose={() => call.end(true)}>
      {children}
    </InfoModal>
  ),
);
